"use client";
import React from 'react';
import CollectionsPage from "./CollectionsPage";

const CoreSequences = () => {
  return <CollectionsPage documentId={'oneQyj4pw77ynzwAF'} />
};

export default CoreSequences;



